import { useContext, useEffect, useRef, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { DistributionOfLandedCostsDetailMain } from "./DistributionOfLandedCostsDetailMain";
import { DistributionOfLandedCostsDetailExpenses } from "./DistributionOfLandedCostsDetailExpenses";
import { DistributionOfLandedCostsVendorInvoices } from "./DistributionOfLandedCostsVendorInvoices";
import { DistributionOfLandedCostsDetailProducts } from "./DistributionOfLandedCostsDetailProducts";
import { toast } from "react-toastify";
import { DistributionOfLandedCostsDetailFooter } from "./DistributionOfLandedCostsDetailFooter";
import DocumentDetailViewToolbar from "src/components/Shared/DetailViews/DocumentDetailViewToolbar";
import DetailViewPostButton from "src/components/Shared/DetailViews/DetailViewPostButton";
import DetailViewCancelButton from "src/components/Shared/DetailViewCancelButton";
import { IDistributionOfLandedCostsModel } from "../models/IDistributionOfLandedCostsModel";
import useFetchDistributionOfLandedCosts from "../hooks/fetchDocument";
import { DistributionOfLandedCostsService } from "src/services/documents/DistributionOfLandedCostsService";
import { AppEntities } from "src/config/entities";
import { NFTabs } from "src/components/Shared/NewForms/NFTabs";
import { NFSecondTab } from "src/components/Shared/NewForms/NFSecondTab";
import { NFTabContainer } from "src/components/Shared/NewForms/NFTabContainer";
import { NFLoadPanel } from "src/components/Shared/NFLoadPanel";
interface IProps {
  id?: string;
}

export const DistributionOfLandedCostsDetail = ({ id }: IProps) => {
  const [tabIndex, setTabIndex] = useState(0);
  const [isDocumentCalculating, setIsDocumentCalculating] = useState(false);
  const [isDocumentFillingByVendorInvoices, setIsDocumentFillingByVendorInvoices] = useState(false);

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<IDistributionOfLandedCostsModel>({
    mode: "onTouched"
  });

  const { isDocumentLoading, documentModel, postDocument, cancelDocument, updateDocument } = useFetchDistributionOfLandedCosts({ documentId: id });

  useEffect(() => {
    if (documentModel) {
      reset(documentModel);
    }
  }, [documentModel]);

  useEffect(() => {
    if (formState.isDirty) {
      console.log("formState.isDirty", formState.isDirty);
      updateDocument(getValues());
    }
  }, [formState.isDirty]);

  const handlePost = async () => {
    await postDocument();
  };

  const handleCancel = async () => {
    await cancelDocument();
  };
  const [fileName, setFileName] = useState("Distribution Of Landed Costs");

  // const exportToExcel = () => {
  //   const data = {
  //     ...model
  //   };
  //   const documentInfo = {
  //     title: AppEntities.DistributionOfLandedCosts.title,
  //     number: model.documentNumber,
  //     date: model.documentDate
  //   };
  //   saveObjectToExcel(data, documentInfo);
  // };

  // const handleUploadFile = (file: File) => {
  //   importFromExcel(file, (data: any) => {
  //     reset(data);
  //   });
  // };

  const handleDoCalculate = async () => {
    try {
      setIsDocumentFillingByVendorInvoices(true);
      const vendorInvoices = getValues("vendorInvoices");
      const vendorInvoiceIds = vendorInvoices.map((x) => x.vendorInvoiceId);

      const dataService = AppEntities.DistributionOfLandedCosts.getDataService() as DistributionOfLandedCostsService;
      const requestDto = {
        vendorInvoices: vendorInvoiceIds,
        expenses: getValues("expenses")
      };
      const responseDto = await dataService.getProductsFromVendorInvoices(requestDto);
      const newProducts = responseDto.map((product) => {
        const newProduct: any = {
          ...product,
          productModel: {
            vendorCode: ""
          }
        };
        return newProduct;
      });
      setValue("products", newProducts);
    } catch (e) {
      console.log(e);
      toast.error("Error while filling document by vendor invoices");
    } finally {
      setIsDocumentFillingByVendorInvoices(false);
    }
  };

  return (
    <FormProvider
      getValues={getValues}
      setValue={setValue}
      register={register}
      control={control}
      trigger={trigger}
      reset={reset}
      watch={watch}
      handleSubmit={handleSubmit}
      formState={formState}
      {...methods}
    >
      <NFTabs
        onTabChange={(newIndex) => {
          setTabIndex(newIndex);
        }}
      >
        <NFSecondTab title={"Main"} />
        <NFSecondTab title={"Vendor Invoices"} />
        <NFSecondTab title={"Expenses"} />
        <NFSecondTab title={"Products"} />
      </NFTabs>
      <div className={"modal-container-height"}>
        <DocumentDetailViewToolbar>
          <DetailViewPostButton onPost={handlePost} />
          <DetailViewCancelButton onCancel={handleCancel} />
          {/*<DetailViewToolbarMoreActions handleUploadFile={handleUploadFile} exportToExcel={exportToExcel}*/}
          {/*                              fileName={fileName} setFileName={setFileName}/>*/}
        </DocumentDetailViewToolbar>
        {/* <DocumentModalViewHeader
          onPost={handleSubmit((data) => handleFormSubmitLocal("post", data))}
          onSave={handleSubmit((data) => handleFormSubmitLocal("save", data))}
          onClose={closeHandler}
          onCancel={cancelHandler}
          handleUploadFile={handleUploadFile}
          exportToExcel={exportToExcel}
          fileName={fileName}
          setFileName={setFileName}
        >
          <LoadingButton
            isLoading={isDocumentFillingByVendorInvoices}
            imageCssClass={"fa-solid fa-fill-drip"}
            cssClass={"btn btn-light ms-2"}
            onClick={handleDoCalculate}
            buttonType={"button"}
            text={"Calculate"}
          />
        </DocumentModalViewHeader> */}
        <NFTabContainer index={0} currentIndex={tabIndex}>
          <DistributionOfLandedCostsDetailMain />
        </NFTabContainer>

        <NFTabContainer index={1} currentIndex={tabIndex}>
          <DistributionOfLandedCostsVendorInvoices />
        </NFTabContainer>

        <NFTabContainer index={2} currentIndex={tabIndex}>
          <DistributionOfLandedCostsDetailExpenses />
        </NFTabContainer>

        <NFTabContainer index={3} currentIndex={tabIndex}>
          <DistributionOfLandedCostsDetailProducts />
        </NFTabContainer>
      </div>
      <NFLoadPanel isLoading={isDocumentCalculating || isDocumentFillingByVendorInvoices} />
      <DistributionOfLandedCostsDetailFooter />
    </FormProvider>
  );
};
